import { render } from "./CustomAccountSearchElement.vue?vue&type=template&id=3b6e6195&scoped=true"
import script from "./CustomAccountSearchElement.vue?vue&type=script&lang=js"
export * from "./CustomAccountSearchElement.vue?vue&type=script&lang=js"

import "./CustomAccountSearchElement.vue?vue&type=style&index=0&id=3b6e6195&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6e6195"]])

export default __exports__